import request from 'ynf-core-engine/request'

import { GET_TPL_ID_URL, GET_AUTH_URL, TPL_META_URL, GET_COMMON_OPTION } from '@config'
import NotFoundPage from '../views/NotFoundView'
/**
 *
 * @param { "tplMode":0
    "businessStepCode":"st01",
    "orgId":"1622072043823431681",
    "transTypeId":"1628016931418669059",} billNo
 * @param {*} domainKey
 * @param {*} params
 * @returns
 */
const getTplId = async (billNo, params) => {
  return new Promise((resolve, jet) => {
    const newParams = checkMultipleTemplates(params)
    const url = `${GET_TPL_ID_URL}`
    post(url, { billNo, ...newParams }, params, { accept: 'application/json, */*' }).then(res => {
      resolve({
        data: res?.data,
        tplId: res?.data?.tplId + ''
      })
    }).catch(err => {
      const errorMsg = getErrorMsg(url, err, params)
      console.info('接口异常', errorMsg)
      resolve()
    });
  })
}
const checkMultipleTemplates = (params) => {// 参数不区分优先级
  const { businessStepCode, mode, terminalType, billId, orgId, transTypeId } = params
  const tplMode = terminalType == 3 ? 3 : ((mode == 'edit' || mode == 'add') ? 2 : 0)
  return { businessStepCode, tplMode, orgId, transTypeId, detailId: billId, terminalType }
}

/**
 * meta缺少缓存处理
 * @param {*} billNo
 * @returns
 */
const getTplAndMeta = async (params) => {
  const { billNo, domainKey, refresh, serviceCode = '', feV, tplId, billId, ...other } = params
  return new Promise((resolve, jet) => {
    let url = `${TPL_META_URL}?bilnum=${billNo}`
    if (feV) url = url + `&feV=${feV}`
    // 多传一个detailId可以省去详情打开切模板的时间
    if (billId) other.detailId = billId
    post(url, { billNo, domainKey, tplid: tplId, ...formatParams(other) }, params).then(res => {
      const metaData = res?.data.meta;
      metaData['businessStepInfo'] = res?.data.tpl?.businessStepInfo;
      metaData['metaResource'] = res?.data.metaResource
      resolve(metaData)
    }).catch(err => {
      resolve(getErrorMsg(url, err, params))
    });
  })
}
const formatParams = (bodyParams) => {// 参数不区分优先级
  const newParams = { ...bodyParams }
  const paramsArr = ['billNo', 'tplMode', 'terminalType', 'transTypeId', 'orgId', 'businessStepCode', 'refCode', 'extTypeId', 'serviceCode', 'extParamMap', 'uiAssignDataMap', 'systemCode', 'detailId', 'businessStepCode', 'busiObj', 'tplid']
  for (let key in newParams) {  
    if (!paramsArr.includes(key)) {  
      delete newParams[key]; 
    }  
  }
  return newParams
}

const getAuthKey = async (billNo, params) => {
  const { from_mc_workflow, billId } = params
  return new Promise((resolve, jet) => {
    const url = `${GET_AUTH_URL}?domainKey=${params.domainKey}&billNo=${billNo}&id=${params.billId}&busiObj=${params.busiObj}`
    request({ url, method: 'get', params: { from_mc_workflow, billId } }).then(res => {
      resolve(res)
    }).catch(err => {
      const errorMsg = getErrorMsg(url, err, params)
      console.info('接口异常', errorMsg)
      resolve()
    });
  })
}

/**
 * 暂时先不转移，并不是所有请求都要这样返回
 */
const getErrorMsg = (url, data, params) => {
  let errorMsg = `url: ${url}${lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B8002B', '\n 请求返回：')}${typeof data == 'string' ? data : JSON.stringify(data)}`
  console.info('接口异常', errorMsg)
  if (data.code == 500) {
    errorMsg = `${url}${lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B8002C', '\n 请求异常, 请检查控制台日志')}`
  }
  if (data.code == 999) {
    errorMsg = data.message
  }
  const container = document.createElement("div");
  const parentDiv = document.getElementById(params.fragmentId) || document.getElementById(`root`) || document.body;
  parentDiv.appendChild(container);
  window.ReactDOM.render(<NotFoundPage text={errorMsg} params={params}></NotFoundPage>, container)
  return errorMsg
}

/**
 * 使用二方包里面的 request
 */
const post = (url, data, params = {}, headers) => {
  return request({
    url,
    data,
    params,
    headers
  })
}

const getCommonOption = async (terminalType) => {
  return new Promise((resolve, jet) => {
    const url = `${GET_COMMON_OPTION}${terminalType}`
    post(url).then(res => {
      resolve(res?.data)
    }).catch(err => {
      console.info('接口异常', err)
      resolve()
    });
  })
}

export {
  getTplId,
  getAuthKey,
  getTplAndMeta,
  getCommonOption
}
